import React from "react";
import { motion } from "framer-motion";
import { FiCheckCircle } from "react-icons/fi";
import SectionHeading from "../../components/SectionHeading";
import { aboutIcons } from "./aboutIcons";
import { whyChooseContent } from "./aboutContent";

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

const AboutWhyChoose = () => (
  <section
    className="bg-gray-50 py-14 lg:py-20"
    aria-labelledby="about-why-choose-heading"
  >
    <div className="sectionlayout">
      <SectionHeading
        id="about-why-choose-heading"
        title={whyChooseContent.title}
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-6 p-0 lg:grid-cols-3 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.15 }}
        variants={{ visible: { transition: { staggerChildren: 0.09 } } }}
      >
        {whyChooseContent.blocks.map((block) => {
          const Icon = aboutIcons[block.icon];
          return (
            <motion.li
              key={block.title}
              variants={cardVariants}
              className="brand-card p-6 lg:p-8"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-[var(--brand-primary)] text-white shadow-md">
                <Icon aria-hidden="true" className="h-5 w-5" />
              </span>
              <h3 className="mt-5 text-lg font-bold text-gray-900">
                {block.title}
              </h3>
              {block.description && (
                <p className="mt-3 text-sm md:text-base leading-relaxed text-gray-600">
                  {block.description}
                </p>
              )}
              {block.intro && (
                <p className="mt-3 text-sm md:text-base leading-relaxed text-gray-600">
                  {block.intro}
                </p>
              )}
              {block.items && (
                <ul className="mt-4 space-y-2.5">
                  {block.items.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <FiCheckCircle
                        aria-hidden="true"
                        size={20}
                        className="mt-0.5 flex-shrink-0 text-[var(--brand-primary)]"
                      />
                      <span className="text-sm md:text-base text-gray-700">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              )}
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default AboutWhyChoose;
